module.exports = __webpack_public_path__ + "img/image.32a42e20.svg";